var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loaded
        ? _c("div", { staticClass: "nav" }, [
            _c(
              "div",
              { staticClass: "top clear gray", class: "bdg-" + _vm.tenant },
              [_c("div", { staticClass: "logo", class: "logo-" + _vm.tenant })]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.curStatus === "normal" &&
      _vm.loaded &&
      _vm.$route.path.split("/")[2] !== "write" &&
      _vm.$route.path.split("/")[2] !== "selection" &&
      _vm.$route.path.split("/")[2] !== "complete" &&
      _vm.construction != true
        ? _c("div", { staticClass: "head", class: { unfold: _vm.unfold } }, [
            _c("div", { staticClass: "tit", on: { click: _vm.fold } }, [
              _vm._v(_vm._s(_vm.cur))
            ]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.list, function(item) {
                return _c(
                  "li",
                  {
                    key: item.id,
                    on: {
                      click: function($event) {
                        return _vm.dtl(item.path)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        class: [
                          _vm.tenantClassCur(item.match),
                          _vm.tenantClass(item.match)
                        ]
                      },
                      [_vm._v(_vm._s(item.val))]
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.curStatus === "normal" && _vm.loaded ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _vm.curStatus === "normal" && _vm.loaded
        ? _c("div", { staticClass: "fotWrap" }, [
            _c("div", { staticClass: "fotCon" }, [
              _c("div", { staticClass: "top clear" }, [
                _c("div", {
                  staticClass: "logo",
                  class: "logoOnWhite-" + _vm.tenant
                }),
                _vm._v(" "),
                _c("div", { staticClass: "share clear" }, [
                  _vm.socialTwitter != null
                    ? _c("a", {
                        staticClass: "twitter",
                        attrs: { href: _vm.socialTwitter, target: "_blank" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.socialFacebook != null
                    ? _c("a", {
                        staticClass: "facebook",
                        attrs: { href: _vm.socialFacebook, target: "_blank" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.socialInstagram != null
                    ? _c("a", {
                        staticClass: "ins",
                        attrs: { href: _vm.socialInstagram, target: "_blank" }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bottom" }, [
                _c(
                  "p",
                  { staticStyle: { "padding-bottom": ".2rem" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { tag: "strong", to: "/term2" } },
                      [_c("i", [_vm._v("Terms & Conditions")])]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { tag: "strong", to: "/policy2" } },
                      [_c("i", [_vm._v("Privacy Policy")])]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticStyle: { "text-decoration": "none" } }, [
                  _vm._v(
                    "\n            team@unifiproperty.com COPYRIGHT 2020\n          "
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.curStatus === "delete" && _vm.loaded
        ? _c(
            "div",
            {
              staticStyle: {
                "padding-top": "62px",
                "font-size": "20px",
                "font-family": "ProximaNova-Regular, ProximaNova",
                color: "#3F3F46",
                "line-height": "20px",
                "text-align": "center"
              }
            },
            [
              _vm._v(
                "\n      The sharing link for this property has been closed.\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show && _vm.loaded
        ? _c("div", { staticClass: "loginWrapper" }, [
            _c("div", { staticClass: "innerWrapper" }, [
              _c("div", { staticClass: "upper" }, [
                _c("div", { staticClass: "top" }, [
                  _c("div", {
                    staticClass: "logo",
                    class: "logo2-" + _vm.tenant
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "popWrapper", class: "tenant-" + _vm.tenant },
                [
                  _c("h1", { class: "tenant-" + _vm.tenant }, [
                    _vm._v("Property is protected")
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "inputItem" }, [
                      _c("i", { staticClass: "title" }, [
                        _vm._v("Enter Passphrase")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pswd,
                            expression: "pswd"
                          }
                        ],
                        attrs: { maxlength: "12", type: "password" },
                        domProps: { value: _vm.pswd },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pswd = $event.target.value
                            },
                            function($event) {
                              _vm.pswd = _vm.pswd.replace(/\s+/g, "")
                              if (_vm.pswd !== "") {
                                _vm.disable = false
                              } else {
                                _vm.disable = true
                              }
                            }
                          ],
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              $event.keyCode !== 13
                            ) {
                              return null
                            }
                            return _vm.save($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "colored",
                        class: { disabled: _vm.disable },
                        attrs: { disabled: _vm.disable },
                        on: { click: _vm.save }
                      },
                      [_vm._v("\n              Open Property\n            ")]
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              If you don't have the passphrase to unlock this preview, please\n              ask the sender to share it with you.\n            "
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4835334", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4835334","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/index.vue
// module id = null
// module chunks = 